export const transitionCubicBezier = {
  transition: "cubic-bezier(0.1, 0.7, 0.6, 0.9) 0.8s",
};

export const slideBasedOnMarginLeft = (
  loadedAnimation: boolean,
  startPoint: string,
  endPoint: string
) => ({
  opacity: loadedAnimation ? "100%" : "0%",
  marginLeft: loadedAnimation
    ? `${startPoint} !important`
    : `${endPoint} !important`,
  ...transitionCubicBezier,
});

export const slideBasedOnLeft = (
  loadedAnimation: boolean,
  startPoint: string,
  endPoint: string
) => ({
  opacity: loadedAnimation ? "100%" : "0%",
  left: loadedAnimation ? `${startPoint}` : `${endPoint}`,
  ...transitionCubicBezier,
});

export const slideBasedOnRight = (
  loadedAnimation: boolean,
  startPoint: string,
  endPoint: string
) => ({
  opacity: loadedAnimation ? "100%" : "0%",
  right: loadedAnimation ? `${startPoint}` : `${endPoint}`,
  ...transitionCubicBezier,
});

export const slideBasedOnMarginRight = (
  loadedAnimation: boolean,
  startPoint: string,
  endPoint: string
) => ({
  opacity: loadedAnimation ? "100%" : "0%",
  marginRight: loadedAnimation ? startPoint : endPoint,
  ...transitionCubicBezier,
});

export const slideBasedOnMarginTop = (
  loadedAnimation: boolean,
  startPoint: string,
  endPoint: string
) => ({
  opacity: loadedAnimation ? "100%" : "0%",
  marginTop: loadedAnimation ? startPoint : endPoint,
  ...transitionCubicBezier,
});

export const fadeIn = (loadedAnimation: boolean) => ({
  opacity: loadedAnimation ? "100%" : "0%",
});

export const scaleUP = (loadedAnimation: boolean) => ({
  transform: loadedAnimation ? "scale(1)" : "scale(0.1)",
});
